
import { Component, Prop, Vue } from 'vue-property-decorator'
import Actions from '@/components/bis_list/actions.vue'
import BIS from '@/components/bis_list/bis.vue'
import Current from '@/components/bis_list/current.vue'
import Details from '@/components/bis_list/details.vue'
import Filters from '@/components/bis_list/filters.vue'
import BISListModify from '@/dataclasses/bis_list_modify'
import { CharacterDetails } from '@/interfaces/character'
import { BISListErrors } from '@/interfaces/responses'

@Component({
  components: {
    Actions,
    BIS,
    Current,
    Details,
    Filters,
  },
})
export default class BISListMobileForm extends Vue {
  tabsShown = {
    bis: false,
    current: false,
    details: true,
    filters: false,
  }

  @Prop()
  bisList!: BISListModify

  @Prop()
  character!: CharacterDetails

  @Prop()
  charIsProxy!: boolean

  @Prop()
  displayOffhand!: boolean

  @Prop()
  errors!: BISListErrors

  @Prop()
  etroImportable!: boolean

  @Prop()
  importLoading!: boolean

  // Set up default values for min and max IL, will change as new tiers are released
  @Prop()
  maxIl!: number

  @Prop()
  method!: string

  @Prop()
  minIl!: number

  // Hide actions that spawn a popup, when used in the add bis section
  @Prop()
  simpleActions!: boolean

  @Prop()
  syncable!: boolean

  @Prop()
  url!: string

  get displayCopy(): boolean {
    return !(this.simpleActions || this.charIsProxy)
  }

  // Method toggle for the tabs
  showBIS(): void {
    this.showNone()
    this.tabsShown.bis = true
  }

  showCurrent(): void {
    this.showNone()
    this.tabsShown.current = true
  }

  showDetails(): void {
    this.showNone()
    this.tabsShown.details = true
  }

  showFilters(): void {
    this.showNone()
    this.tabsShown.filters = true
  }

  // Reset the object
  showNone(): void {
    this.tabsShown.current = false
    this.tabsShown.bis = false
    this.tabsShown.details = false
    this.tabsShown.filters = false
  }

  // Functions to indicate if a tab has errors
  get bisTabHasErrors(): boolean {
    return (
      this.errors.bis_mainhand_id !== undefined
      || this.errors.bis_offhand_id !== undefined
      || this.errors.bis_head_id !== undefined
      || this.errors.bis_body_id !== undefined
      || this.errors.bis_hands_id !== undefined
      || this.errors.bis_legs_id !== undefined
      || this.errors.bis_feet_id !== undefined
      || this.errors.bis_earrings_id !== undefined
      || this.errors.bis_necklace_id !== undefined
      || this.errors.bis_bracelet_id !== undefined
      || this.errors.bis_right_ring_id !== undefined
      || this.errors.bis_left_ring_id !== undefined
    )
  }

  get currentTabHasErrors(): boolean {
    return (
      this.errors.current_mainhand_id !== undefined
      || this.errors.current_offhand_id !== undefined
      || this.errors.current_head_id !== undefined
      || this.errors.current_body_id !== undefined
      || this.errors.current_hands_id !== undefined
      || this.errors.current_legs_id !== undefined
      || this.errors.current_feet_id !== undefined
      || this.errors.current_earrings_id !== undefined
      || this.errors.current_necklace_id !== undefined
      || this.errors.current_bracelet_id !== undefined
      || this.errors.current_right_ring_id !== undefined
      || this.errors.current_left_ring_id !== undefined
    )
  }

  get detailsTabHasErrors(): boolean {
    return (
      this.errors.job_id !== undefined
      || this.errors.external_link !== undefined
    )
  }

  importEtroBis(): void {
    this.$emit('import-etro-bis-data')
  }

  importFromOtherList(): void {
    this.$emit('import-current-data')
  }

  importLodestone(): void {
    this.$emit('import-current-lodestone-gear')
  }

  importXIVGearBis(): void {
    this.$emit('import-xivgear-bis-data')
  }
}
